/** Inline icons from nira.html (decorative; the buttons carry the labels). */
const base = { viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeLinecap: "round", "aria-hidden": true } as const

export const PlusIcon = () => <svg {...base} strokeWidth="1.6"><path d="M10 4v12M4 10h12" /></svg>
export const LockIcon = () => (
  <svg {...base} strokeWidth="1.6"><rect x="4.5" y="9" width="11" height="8" rx="1.5" /><path d="M7 9V6.5a3 3 0 0 1 6 0V9" /></svg>
)
export const ClockIcon = () => (
  <svg {...base} strokeWidth="1.5" strokeLinejoin="round"><circle cx="10" cy="10" r="7" /><path d="M10 6v4l2.5 2" /></svg>
)
export const GearIcon = () => (
  <svg {...base} strokeWidth="1.5" strokeLinejoin="round">
    <circle cx="10" cy="10" r="2.6" />
    <path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M4.7 15.3l1.4-1.4M13.9 6.1l1.4-1.4" />
  </svg>
)
export const SunIcon = () => (
  <svg {...base} strokeWidth="1.5">
    <circle cx="10" cy="10" r="3.4" />
    <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.3 4.3l1.4 1.4M14.3 14.3l1.4 1.4M4.3 15.7l1.4-1.4M14.3 5.7l1.4-1.4" />
  </svg>
)
export const MoonIcon = () => (
  <svg {...base} strokeWidth="1.5" strokeLinejoin="round"><path d="M16.5 11.5A6.5 6.5 0 0 1 8.5 3.5a6.5 6.5 0 1 0 8 8Z" /></svg>
)
export const CloseIcon = () => <svg {...base} strokeWidth="1.6"><path d="m5 5 10 10M15 5 5 15" /></svg>
export const MenuIcon = () => <svg {...base} strokeWidth="1.6"><path d="M3.5 6h13M3.5 10h13M3.5 14h13" /></svg>
export const SectionsIcon = () => (
  <svg {...base} width="15" height="15" strokeWidth="1.6">
    <path d="M5 3.5v13" /><circle cx="5" cy="6" r="1.6" /><circle cx="5" cy="14" r="1.6" /><path d="M9.5 6h6M9.5 14h6" />
  </svg>
)
export const ChevIcon = () => (
  <svg {...base} className="chev" strokeWidth="1.6" strokeLinejoin="round"><path d="m5 8 5 5 5-5" /></svg>
)
export const AttachIcon = () => (
  <svg {...base} strokeWidth="1.5" strokeLinejoin="round">
    <path d="m16 9.5-6.2 6.2a3.6 3.6 0 0 1-5.1-5.1l6.6-6.6a2.4 2.4 0 0 1 3.4 3.4l-6.6 6.6a1.2 1.2 0 0 1-1.7-1.7L12 6.5" />
  </svg>
)
export const SendIcon = () => (
  <svg {...base} strokeWidth="1.8" strokeLinejoin="round"><path d="M10 16V4M4.5 9.5 10 4l5.5 5.5" /></svg>
)
